import React, { Fragment } from 'react';
import ReactGA from 'react-ga';
import MedicationListModalData from './MedicationListModalData';

function QuestionLink({ question, toggleMedicationListModal }) {
  const medicationList = MedicationListModalData.text[question.medicationList];
  return (
    <Fragment>
      {question.hasWastageCalculator && (
        <Fragment>
          <div className="new-assessment-detail__wastage-calculator-wrapper">
            <ReactGA.OutboundLink
              to="/documents/wastage-calculator.xlsx"
              className="flat-link"
              eventLabel="Download Wastage Calculator"
              target="_blank"
              download
            >
              Download Wastage Calculator (Excel Spreadsheet)
            </ReactGA.OutboundLink>
          </div>
          <div className="new-assessment-detail__link-description">
            This calculator is provided to understand the amount of wastage that occurs from drugs that are drawn up and not used and to be part of your analysis following the observation.
          </div>
        </Fragment>
      )}
      {question.hasMedicationList && (
        <Fragment>
          <div className="new-assessment-detail__wastage-calculator-wrapper">
            <button type="button" className="flat-link-from-button" onClick={toggleMedicationListModal}>
              View List
            </button>
          </div>
          <div className="new-assessment-detail__link-description">
            {medicationList && medicationList.subtext}
          </div>
        </Fragment>
      )}
    </Fragment>
  );
}

export default QuestionLink;



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionLink.js